export default "__VITE_ASSET__b98a172d__"